import { render } from "./pos.vue?vue&type=template&id=afabd196"
import script from "./pos.vue?vue&type=script&lang=js"
export * from "./pos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__